"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroEventResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const enums_1 = require("../../enums");
class HeroEventResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        Object.assign(this, options);
    }
    getFields() {
        return [
            'id',
            'name',
            'eventRefId',
            'eventCategoryId',
            'allowMultipleEntries',
            'requireScanOut',
            'openToAll',
            'active',
            'duration',
            'startTime',
            'startDate',
            'endDate',
            'recurrenceScheduledDays',
            'skipWeekends',
            'monthlyRecurrence',
            'recurrence',
            'eventCategory'
        ];
    }
    id;
    name;
    eventRefId;
    eventCategoryId;
    eventCategory;
    allowMultipleEntries;
    requireScanOut;
    openToAll;
    active;
    startTime;
    startDate;
    endDate;
    duration;
    recurrenceScheduledDays;
    skipWeekends;
    monthlyRecurrence;
    recurrence;
    students;
    static mapHeroEvents(entities) {
        return mappable_base_1.MappableBase.mapAll(entities, HeroEventResponseDto);
    }
}
exports.HeroEventResponseDto = HeroEventResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], HeroEventResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HeroEventResponseDto.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HeroEventResponseDto.prototype, "eventRefId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], HeroEventResponseDto.prototype, "eventCategoryId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], HeroEventResponseDto.prototype, "eventCategory", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], HeroEventResponseDto.prototype, "allowMultipleEntries", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], HeroEventResponseDto.prototype, "requireScanOut", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], HeroEventResponseDto.prototype, "openToAll", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], HeroEventResponseDto.prototype, "active", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HeroEventResponseDto.prototype, "startTime", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], HeroEventResponseDto.prototype, "startDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], HeroEventResponseDto.prototype, "endDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], HeroEventResponseDto.prototype, "duration", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], HeroEventResponseDto.prototype, "recurrenceScheduledDays", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], HeroEventResponseDto.prototype, "skipWeekends", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], HeroEventResponseDto.prototype, "monthlyRecurrence", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HeroEventResponseDto.prototype, "recurrence", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], HeroEventResponseDto.prototype, "students", void 0);
